import { lazy } from "react";

export type { IAddToNichePopupProps } from "./types";

export const AddToNichePopup = lazy(() => import("./AddToNichePopupContainer"));
